
       $(document).on('click', '.add-to-cart-express-add', function(){
                const quantity = $(this).parents('.quantity-with-cartbutton').find('.quantity').val();
                const variantId = $(this).data("variant-id"); // Get variant ID from the button

                // if (!variantId) {
                //   alert("Please select a product variant.");
                //   return;
                // }

                const formData = {
                  id: variantId,
                  quantity: quantity,
                };

                $.ajax({
                  url: "/cart/add.js",
                  method: "POST",
                  data: formData,
                  dataType: "json",
                  success: function (response) {

                     $("cart-drawer").removeClass("is-empty");
                     $('.cart-count-bubble').load(location.href + ' .cart-count-bubble > *');

                     $('#CartDrawer .drawer__inner').load(location.href + ' #CartDrawer .drawer__inner > *');
                    $("cart-drawer").addClass("active");


                    setTimeout(function(){


                         $('.drawer-slider').slick({
                              dots: true,
                              infinite: true,
                              speed: 1000,
                              slidesToShow: 1,
                              slidesToScroll: 1,
                              autoplay: false,
                              autoplaySpeed: 2000,
                              arrows: true,
                              responsive: [{
                                breakpoint: 1400,
                                settings: {
                                          dots: false,
                                    arrows: false,

                                  slidesToShow: 1,
                                  slidesToScroll: 1
                                }
                              },
                              {
                                 breakpoint: 600,
                                 settings: {
                                      dots: false,
                                    arrows: false,
                                    slidesToShow: 1,
                                    slidesToScroll: 1
                                 }
                              }]
                         });
                     }, 2000);


               },
                  error: function (xhr, status, error) {
                    console.error("Error:", error);
                    alert("There was an error adding the product to the cart.");
                  },
              });


             });